import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MetricCardProps {
  metric: {
    id: number;
    icon: string;
    value: string;
    label: string;
    suffix: string;
  };
}

const MetricCard = ({ metric }: MetricCardProps) => {
  return (
    <div className="glassmorphic rounded-xl p-6 text-center shadow-silver-glow hover:shadow-orange-glow-hover transition-all duration-500 card-3d-glow group">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4 group-hover:bg-primary/20 transition-colors duration-300 shadow-orange-glow">
        <Icon name={metric.icon as any} size={32} className="text-primary" />
      </div>
      <div className="text-4xl font-display font-bold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
        {metric.value}
        <span className="text-2xl text-primary">{metric.suffix}</span>
      </div>
      <p className="text-sm text-muted-foreground font-medium">{metric.label}</p>
    </div>
  );
};

export default MetricCard;